module.exports = __webpack_public_path__ + "static/invites_dribbble-2025e49feac4727f1aa4afff5d751e60.mp4";